<template>
  <div class="home">
    <!-- <script2 src="../../public/assets/assets/js/jquery-2.2.4.js"></script2> -->
    <!-- <script2 src="/assets/assets/js/common2.js"></script2> -->
    <!-- <script2 src="/assets/assets/js/common_page_home2.js"></script2> -->
    <!-- <script2 src="/assets/js/cbpHorizontalMenu.js"></script2> -->

    <div class="main-wrapper">
      <main role="main">
        <div class="main-contents">
          <div id="kv" class="kv js-intro js-play">
            <div id="kv-inner" class="kv-inner">
              <div class="kv-intro">
                <div class="kv-intro__body">
                  <span class="kv-intro__logo"><img src="/assets/assets/img/home/SS-logo400x400.png" alt="スカンジナビアサービス"></span>
                  <p class="kv-intro__txt text_serif_intro">美容皮膚の現場から生まれた<br>スカンジナビアの美容機器とスキンケア</p>
                </div>
              </div>
              <div class="slideshow-images">
                <div class="viewport">
                  <ul class="slideshow" style="display: none;">

                    <!-- モニター募集 -->
                    <li class="slideshow-cell  pos--L">
                      <div class="kv__cell-body-outer">
                        <div class="kv__cell-body">
                          <h2 class="kv__ttl" v-bind:class="{ margintop300px: !largescreen }"><img src="/assets/assets/img/home/monitordaiboshu.png" alt="モニター募集" class="img"></h2>
                          <p class="kv__btn"><router-link to="/monitortouroku" class="btn">モニター登録フォームへ</router-link></p>
                        </div>
                      </div>
                      <p class="kv__img"><img src="/assets/assets/img/home/s0nt.webp" alt="パワーライト施術風景" class="img"></p>
                    </li>

                    <li class="slideshow-cell  pos--L">
                      <div class="kv__cell-body-outer">
                        <div class="kv__cell-body">
                          <h2 class="kv__ttl" style="margin-top: -300px;"><img src="/assets/assets/img/home/kv_brandstory_title2.png" alt="肌に優しくバルジにしっかり届く光脱毛マシン" class="img"></h2>
                          <p v-if="largescreen===true" class="kv__txt text-serif-100">
                            日本で初めて販売された光脱毛機器「パワーライト」<br>
                            20年以上の歴史を誇るこのマシンは、<br>
                            効果と安全性の高さから、多くのサロン様で導入されています。</p>
                          <p v-if="largescreen===false" id="slider-text-smallscreen" class="kv__txt text-serif-100">
                            日本で初めて販売された光脱毛機器<br>
                            「パワーライト」20年以上の歴史を誇る<br>                           このマシンは、効果と安全性の高さから、<br>
                            多くのサロン様で導入されています。</p>
                          <img v-if="largescreen===true" src="/assets/img/400NEpro35pro55.webp" alt="パワーライトシリーズ" id="pl400nepro35pro55_img" class="img">
                          <img v-if="largescreen===false" src="/assets/img/400NEpro35pro55.webp" alt="パワーライトシリーズ" id="pl400nepro35pro55_img" class="img">
                        </div>
                      </div>
                      <p class="kv__img"><img src="/assets/assets/img/home/s1nt.jpg" alt="女性モデル" class="img"></p>
                    </li>

                    <!-- <li class="slideshow-cell color--wt pos--L"> -->
                    <li class="slideshow-cell pos--L">
                      <div class="kv__cell-body-outer">
                        <div class="kv__cell-body">
                          <h2 class="kv__ttl" v-bind:class="{ margintop300px: !largescreen }"><img src="/assets/assets/img/home/kv_skinpeel_title2.png" alt="テクニックなしでも高い痩身効果を出せる痩身マシン" class="img"></h2>
                          <p v-if="largescreen===true" class="kv__txt text-serif-100">                       リピーターが絶えない衝撃波×セルメルトや着衣のまま
                            施術可能なマシンなどをご提案。特殊な技術がなくても、<br>
                            満足していただく結果を提供します。
                          </p>
                          <p v-if="largescreen===false" id="slider-text-smallscreen" class="kv__txt text-serif-100">                           リピーターが絶えない衝撃波×セルメルトや<br>
                            着衣のまま施術可能なマシンなどをご提案。<br>
                            特殊な技術がなくても、満足して<br>
                            いただく結果を提供します。
                          </p>
                          <p class="kv__btn"><router-link to="/products" class="btn">商品ページへ</router-link></p>
                        </div>
                      </div>
                      <p class="kv__img"><img src="/assets/assets/img/home/s2nt.jpg" alt="女性モデル" class="img"></p>
                    </li>

                    <li class="slideshow-cell pos--L">
                      <div class="kv__cell-body-outer">
                        <div class="kv__cell-body">
                          <h2 class="kv__ttl" v-bind:class="{ margintop300px: !largescreen }"><img src="/assets/assets/img/home/kv_takamilip_title2.png" alt="リラクもボディメイクも育毛ケアも！生体電流マシン" class="img"></h2>
                          <p  v-if="largescreen===true" class="kv__txt text-serif-100">
                            人間が持つ生体電流を模倣し、<br>
                            独自の技術で再現した「マルチスペクトラルウェーブ」で<br>
                            体の不調に働きかけ、改善に導きます。
                          </p>
                          <p v-if="largescreen===false" id="slider-text-smallscreen" class="kv__txt text-serif-100">
                            人間が持つ生体電流を模倣し、<br>
                            独自の技術で再現した<br>
                            「マルチスペクトラルウェーブ」で<br>
                            体の不調に働きかけ、改善に導きます。
                          </p>
                          <p class="kv__btn"><router-link to="/products" class="btn">商品ページへ</router-link></p>
                        </div>
                      </div>
                      <p class="kv__img"><img src="/assets/assets/img/home/s3nt.jpg" alt="背景画像" class="img"></p>
                    </li>

                    <li class="slideshow-cell pos--L">
                      <div class="kv__cell-body-outer">
                        <div class="kv__cell-body">
                          <h2 class="kv__ttl"><img src="/assets/assets/img/home/kv_lotion_title2.png" alt="美肌や小顔を最新技術で叶えるフェイシャルマシン" class="img"></h2>
                          <p v-if="largescreen===true"class="kv__txt text-serif-100">
                            シミやしわなどの肌質を改善したり、<br>
                            たるみやむくみなどの加齢症状に<br>
                            アプローチする最新美顔マシン
                          </p>
                          <p v-if="largescreen===false" id="slider-text-smallscreen" class="kv__txt text-serif-100">
                            シミやしわなどの肌質を改善したり、<br>
                            たるみやむくみなどの加齢症状に<br>
                            アプローチする最新美顔マシン
                          </p>
                          <p class="kv__btn"><router-link to="/products" class="btn">商品ページへ</router-link></p>
                        </div>
                      </div>
                      <p class="kv__img"><img src="/assets/assets/img/home/s4nt.jpg" alt="女性モデル施術風景" class="img"></p>
                    </li>

                    <!-- <li class="slideshow-cell pos--B text--center"> -->
                    <li class="slideshow-cell pos--L">
                      <div class="kv__cell-body-outer">
                        <div class="kv__cell-body">
                          <p v-if="largescreen===true" class="kv__txt text-serif-100">
                            高い効果が求められるサロン施術のためにつくられた<br>
                            基礎化粧品「スノーホワイト」シリーズ。<br>
                            洗顔から美容液まで個性的なアイテムが揃います。
                          </p>
                          <p v-if="largescreen===false" id="slider-text-smallscreen" class="kv__txt text-serif-100">
                            高い効果が求められるサロン施術の<br>
                            ためにつくられた基礎化粧品<br>
                            「スノーホワイト」シリーズ。洗顔から<br>
                            美容液まで個性的なアイテムが揃います。
                          </p>
                          <h2 class="kv__ttl"><img src="/assets/assets/img/home/kv_skincareline_title2.png" alt="スウェーデンの医師と共同で開発したサロン専用コスメティックス" class="img"></h2>
                          <p class="kv__btn"><router-link to="/cosmetics" class="btn">製品一覧</router-link></p>
                        </div>
                      </div>
                      <p class="kv__img"><img src="/assets/assets/img/home/s5nt.jpg" alt="女性モデル" class="img"></p>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>

    <section class="horizontalmenu">
      <div class="container">
        <div class="main">
          <nav id="cbp-hrmenu" class="cbp-hrmenu">
            <ul>
              <li>
                <a href="#"> <img src="/assets/img/face.jpg" alt="FACE顔"> </a>
                <div class="cbp-hrsub">
                  <div class="cbp-hrsub-inner">
                    <div>
                      <ul>
                        <li><router-link to="/pro55">Powerlite Pro55</router-link></li>
                        <li><router-link to="/pro35">Powerlite Pro35</router-link></li>
                        <li><router-link to="/pl400ne">Powerlite 400NE</router-link></li>
                      </ul>
                    </div>
                  </div><!-- /cbp-hrsub-inner -->
                </div><!-- /cbp-hrsub -->
              </li>
              <li>
                <a href="#"> <img src="/assets/img/body.jpg" alt="BODY体"></a>
                <div class="cbp-hrsub">
                  <div class="cbp-hrsub-inner">
                    <div>
                      <ul>
                        <li><router-link to="/pro55">Powerlite Pro55</router-link></li>
                        <li><router-link to="/smartdren">SmartDren</router-link></li>
                        <li><router-link to="/smartdrendual">SmartDren Dual</router-link></li>
                        <!-- <li><a href="#">Evolution Slim</a></li> -->
                       <!--  <li><router-link to="/drpro">Dr-PRO</router-link> </li>-->
                      </ul>
                    </div>
                  </div><!-- /cbp-hrsub-inner -->
                </div><!-- /cbp-hrsub -->
              </li>
              <li>
                <a href="#"> <img src="/assets/img/hair.jpg" alt="HAIR髪"></a>
                <div class="cbp-hrsub">
                  <div class="cbp-hrsub-inner">
                    <div>
                      <ul>
                        <li><router-link to="/hm">Hair Medic</router-link></li>
                        <!-- <li><router-link to="/drpro">Dr-PRO</router-link></li> -->
                        <!-- <li><router-link to="/drprohs">Dr-PRO HS</router-link></li> -->
                      </ul>
                    </div>
                  </div><!-- /cbp-hrsub-inner -->
                </div><!-- /cbp-hrsub -->
              </li>
              <li>
                <a href="#"> <img src="/assets/img/cosme.jpg" alt="化粧品"></a>
                <div class="cbp-hrsub">
                  <div class="cbp-hrsub-inner">
                    <div>
                      <ul>
                        <li><router-link to="/cosmetics">SnowWhite Series</router-link></li>
                        <li><router-link to="/plcosmetics">Powerlite Series</router-link></li>
                        <li><router-link to="/accosmetics">Anti Cellulite Series</router-link></li>
                        <li><router-link to="/hmcosmetics">HAIRMEDIC Series</router-link></li>
                      </ul>
                    </div>
                  </div><!-- /cbp-hrsub-inner -->
                </div><!-- /cbp-hrsub -->
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </section>
    <div class="page_content">
      <div class="box0">
        <div class="box1"><router-link to="/products">商品案内</router-link></div>
        <div class="box1"><router-link to="/support">サポート</router-link></div>
      </div>

      <!-- <br>
           <div class="cosmetics_banner cosme" @click.stop="gotohomecare_drpro">
           <a><img src="/assets/img/homecareseries_top_DRPRO-960x329.png" alt="感動の最新美容テクノロジーDr-PROホームケアシリーズ"></a>
           </div>       -->

      <br>
      <div class="cosmetics_banner cosme">
        <router-link to="/cosmetics"><img src="/assets/img/SW_top_new.webp" alt="うるおいの力で肌本来の美しさを呼び覚ます年齢に左右されない輝く肌へSnowWhiteスノーホワイト化粧品"></router-link>
      </div>

      <br>
      <hr>
      <br>
      <h2 class="news-media-heading">News / ニュース</h2>


      <dl>

<dt>2026/07/02 </dt>
<router-link to="/news260702">
  <dd>夏季休業のお知らせ</dd>
</router-link>

<dt>2026/05/18 </dt>
<router-link to="/newsbw2026tokyo">
  <dd>ビューティーワールド ジャパン 東京出展のお知らせ</dd>
</router-link>

<dt>2026/03/23 </dt>
<router-link to="/newsbw2026nagoya">
  <dd>ビューティーワールド ジャパン 名古屋出展のお知らせ</dd>
</router-link>

<dt>2026/02/16 </dt>
<router-link to="/newsbw2026fukuoka">
  <dd>ビューティーワールドジャパン2026福岡に出展いたします。</dd>
</router-link>


  <dt>2025/12/26 </dt>
  <router-link to="/news20251226">
    <dd>年末年始休業のお知らせ</dd>
  </router-link>

        <dt>2025/07/02 </dt>
        <router-link to="/news251020"><dd>ビューティーワールド ジャパン大阪出展のお知らせ</dd></router-link>
           <!--
 <dt>2025/06/30</dt>
         <dd>ヘアメディックグロー販売終了</dd>
         <dt>2025/06/24 </dt>
        <router-link to="/news250714"><dd>ビューティーワールド ジャパン名古屋出展のお知らせ</dd></router-link>
 <dt>2025/04/01 </dt>
        <router-link to="/news250401"><dd>ビューティーワールド ジャパン東京出展のお知らせ</dd></router-link>
        <dt>2025/02/19 </dt>
        <a href="/products#beauty_jet_jr"><dd>スノーホワイト ビューティジェット ジュニア 発売</dd></a>
        <dt>2025/01/09 </dt>
        <router-link to="/newsBWF2025"><dd>ビューティーワールドジャパン福岡出展のお知らせ</dd></router-link>
    
             <dt>2024/11/18 </dt>
             <dd>スノーホワイト リッチクレンジングミルク販売終了</dd>
             <dt>2024/11/05 </dt>
             <a href="https://scandinavianbeauty.jp/products/kilo-minus-73-5g-3-5g-x-21%E5%8C%85"><dd>ダイエットサプリメント キロマイナス 発売</dd></a>
             <dt>2024/07/24 </dt>
             <router-link to="/news240724bwn"><dd>ビューティーワールド ジャパン名古屋出展 決定！</dd></router-link>
             <dt>2023/09/27 </dt>
             <router-link to="/news231018"><dd>レジャー＆サービス産業展 出展のお知らせ</dd></router-link>
             <dt>2023/09/27 </dt>
             <router-link to="/news231005"><dd>Femtech Tokyo 出展のお知らせ</dd></router-link>
             <dt>2023/07/12 </dt>
             <router-link to="/news230712bwn"><dd>ビューティーワールド ジャパン名古屋出展のお知らせ</dd></router-link>
             <dt>2023/05/01 </dt>
             <router-link to="/news230501"><dd>ビューティーワールド ジャパン出展のお知らせ</dd></router-link>
             <dt>2023/01/25 </dt>
             <router-link to="/news230125bwf"><dd>ビューティーワールドジャパン福岡出展のお知らせ</dd></router-link>
             <dt>2023/01/25 </dt>
             <router-link to="/news230125gs"><dd>第95回 東京インターナショナル ギフト・ショー 春2023に出展のお知らせ</dd></router-link>
             <dt>2022/05/11 </dt>
             <router-link to="/news220511"><dd>ビューティーワールド ジャパン出展のお知らせ</dd></router-link>
             <dt>2022/02/02 </dt>
             <router-link to="/news220202"><dd>ビューティーワールドジャパン福岡出展のお知らせ</dd></router-link>
             <dt>2022/01/11 </dt>
             <router-link to="/news220111"><dd>【重要】弊社製品の転売・保証について</dd></router-link>
             <dt>2021/10/04 </dt>
             <router-link to="/news211004"><dd>10/13(水)東京ギフトショー×NEXT LEADER　出展のおしらせ</dd></router-link>
             <dt>2021/05/24 </dt>
             <router-link to="/news210524"><dd>【名古屋】6/17(木)〜19(土)スポーツ・ウェルネス産業総合展に出展します</dd></router-link>
             <dt>2020/12/17 </dt>
             <dd>冬期休暇は2020年12月26日(土)〜1月3日(日)となり、通常営業は1月4日(月)からとなります。</dd>
             <dt>2020/05/14 </dt>
             <dd>■重要なお知らせ■<br>
             新型コロナウィルス感染拡大の状況を考慮し、弊社では4月21日(火)から5月末日(日)まで勤務人数を縮小しての営業となります。 それに伴い、エンジニアの土日祝日のスタンバイも休止とさせていただきます。修理等の対応は6月1日（月）以降となりますのでご協力お願いいたします。
             電話でのお問い合わせは受け付けておりますが、返答までにお時間を頂戴する場合がございますので、予めご了承ください。
             なお、商品のご注文に関しては通常通り発送が可能ですが、大量のご注文等はお時間と頂戴する可能性がございます。
             また、当日出荷の締め切り時間を平日15時から14時に変更とさせていただきます。
             ご不便をお掛けし申し訳ございませんが、ご理解の程よろしくお願いいたします。</dd>
             <dt>2019/07/02 </dt>
             <router-link to="/sugaringseminar"><dd>SUN KISSED Skin セミナー開始！</dd></router-link>
             <dt>2019/05/23 </dt>
             <dt>2019/06/07 </dt>
             <router-link to="/BeautySpecialistAward"><dd>Beauty Specialist Award 開催決定！</dd></router-link>
             <dt>2019/05/23 </dt>
             <router-link to="/sugaring"><dd>「SUN KISSED Skin」シュガーリング脱毛新発売。</dd></router-link>
             <dt>2019/04/12 </dt>
             <router-link to="/bw2019"><dd>「ビューティーワールドジャパン2019」に出展いたします。</dd></router-link>
             <dt>2019/03/01 </dt>
             <dd>ランプキャンペーン</dd>
             <dt> </dt>
             <dt>2019/02/07 </dt>
             <a href="/assets/img/MISS-JAPAN-BEAUTY-kekka.jpg" target="_blank"><dd>MISS JAPAN BEAUTY コンテストグランプリ結果発表</dd></a>
             <dt>2018/12/29 </dt>
             <dd>冬期休暇は2018年12月29日(土)〜1月3日(木)となり、通常営業は1月4日(金)からとなります。</dd>
             <dt>2018/05/01 </dt>
             <dd>Miss Japan Beauty 開催</dd>
             <dt>2018/04/22 </dt>
             <dd>コスメキャンペーン</dd>
             <dt>2018/04/01 </dt>
             <dd>ランプキャンペーン</dd>
             <dt> </dt>
             <dd>Smart Dren DUAL</dd>
             <dt>2018/03/01 </dt>
             <dd>Scandinavia News Spring/Summer</dd>-->
        
      </dl>

      <br>
      <hr>
      <br>
      <h2 class="news-media-heading">Media / 掲載</h2>
      <dl>
        <dt>2021/08/26 </dt>
        <a href="https://prtimes.jp/main/html/rd/p/000000004.000077721.html" target="_blank"><dd>９月１日発売「Dr-PROビューティーシークレット」サロン限定新色のプレスリリース
          が掲載されました</dd></a>
        <dt>2018/11/10 </dt>
        <a href="/assets/img/esthetic-wired.jpg" target="_blank"><dd>Esthetic Wired 12月号　ベストアイテム2018受賞</dd></a>
        <dt>2018/05/02 </dt>
        <dd>Esthetic Beauty 5月号</dd>
      </dl>


      <br>
      <hr>
      <br>
    </div>

    <footer2></footer2>

  </div>
</template>

<script>
 // import $ from "jquery";
 // @ is an alias to /src
 // var cbpHorizontalMenu = require('../../public/assets/js/cbpHorizontalMenu.min.js');
 export default {
   name: 'home',
   props: {
     largescreen: {
       type: Boolean
     }
   },
   components: {
     footer2: () => import('../components/Footer2.vue')
   },
   created() {
     /* document.addEventListener('DOMContentLoaded', function() {
      *   'use strict';
      *   console.log("DOM fully loaded and parsed");
      *   var $segment_1 = $('.slideshow');
      *   $segment_1.eq(0).show();
      * }, false); */


     /* document.addEventListener("DOMContentLoaded", function () {
      *   var body = document.getElementsByTagName("body")[0];
      *   var kv = document.getElementById("kv");
      *   kv.classList.add("js-intro");
      *   Keyvisual.intro.init();
      *   Keyvisual.parallax();
      *
      *   if (UA.browser === "msie" || UA.browser === "edge") {
	$("body").niceScroll({
	cursorcolor: "#b9b9b9",
	cursorwidth: "12px",
	cursorborderradius: "0px",
	cursorborder: "none",
	background: "#e6e6e6",
	autohidemode: false,
	railoffset: true,
	nativeparentscrolling: false,
	zindex: 101
	});
      *   }
      *
      * }, false); */
   },
   mounted() {
     Keyvisual.intro.init();
     Keyvisual.parallax();
     $('.slideshow').eq(0).show();

     document.addEventListener("DOMContentLoaded", function () {
       var body = document.getElementsByTagName("body")[0];
       var kv = document.getElementById("kv");
       kv.classList.add("js-intro");
       Keyvisual.intro.init();
       Keyvisual.parallax();

       if (UA.browser === "msie" || UA.browser === "edge") {
	 $("body").niceScroll({
	   cursorcolor: "#b9b9b9",
	   cursorwidth: "12px",
	   cursorborderradius: "0px",
	   cursorborder: "none",
	   background: "#e6e6e6",
	   autohidemode: false,
	   railoffset: true,
	   nativeparentscrolling: false,
	   zindex: 101
	 });
       }

     }, false);

     const plugin = document.createElement("script");
     plugin.setAttribute(
       "src",
       // added cbpHorizontalMenu.init(); at the end of cbpHorizontalMenu.js to make it work
       "/assets/js/cbpHorizontalMenu.js"
     );
     // plugin.async = true;
     plugin.async = false;
     document.head.appendChild(plugin);



     // Adding the file inline worked below

     // var cbpHorizontalMenu = (function() {

     //     var $listItems = $( '#cbp-hrmenu > ul > li' ),
     //         $menuItems = $listItems.children( 'a' ),
     //         $body = $( 'body' ),
     //         current = -1;

     //     function init() {
     //         $menuItems.on( 'click', open );
     //         $listItems.on( 'click', function( event ) { event.stopPropagation(); } );
     //     }

     //     function open( event ) {
     //         if( current !== -1 ) {
     //             $listItems.eq( current ).removeClass( 'cbp-hropen' );
     //         }
     //         var $item = $( event.currentTarget ).parent( 'li' ),
     //             idx = $item.index();
     //         if( current === idx ) {
     //             $item.removeClass( 'cbp-hropen' );
     //             current = -1;
     //         }
     //         else {
     //                 $item.addClass( 'cbp-hropen' );
     //             current = idx;
     //             $body.off( 'click' ).on( 'click', close );
     //         }
     //         return false;
     //     }
     //     function close( event ) {
     //         $listItems.eq( current ).removeClass( 'cbp-hropen' );
     //         current = -1;
     //     }
     //     return { init : init };
     // })();

     // cbpHorizontalMenu.init();

   },
   methods: {
     gotohomecare_drpro() {
       window.location.href = "https://scandinavianbeauty.jp/products/ドクタープロ-ビューティシークレット"
     },
   }
 };

</script>

<style lang="scss">
 /* slider */
 @import "../../public/assets/assets/css/base2.scss";
 @import "../../public/assets/assets/css/module2.scss";
 @import "../../public/assets/assets/css/page_home.scss";

 /* horizontalmenu */
 @import "../../public/assets/scss/component.scss";

 @import "../../public/assets/scss/style.scss";

 /* menu floats above slider in index.html only */
 #scmenu .menu-section {
   position: absolute;
   margin-left: -30px;
   z-index: 11;
 }
 @media (min-width: 601px) {
   .menu-section {
     top: 53px;
   }
 }
 @media (max-width: 600px) {
   .menu-section {
     margin-left: 0;
   }
 }
 .menu-back {
   position: absolute;
   left: 0;
   height: 50px;
   width:100%;
   background-color: #fff;
   opacity: 0.9;
   z-index: 10;
   filter: drop-shadow(3px 3px 3px #ddd);
   border-top: 1px solid #ccc;
   border-bottom: 1px solid #ccc;
 }

 .text_serif_intro {
   font-family: serif;
 }

 /* for large screens */
 .kv__ttl img {
   width: 500px;
 }

 #pl400nepro35pro55_img {
   width: 300px;
   height: auto;
   position:absolute;
   top: 50%;
   left: 70%;
 }
 .margintop300px {
   margin-top: -300px;
 }
 /* ----------- iPhone 6+, 7+ and 8+ ----------- */
 @media (max-width: 414px) {
   .text_serif_intro {
     font-family: serif;
     letter-spacing: -2px;
   }
   .kv-intro__body {
     width: 400px;
   }
   .kv__ttl img {
     width: 390px;
   }
   .kv-intro {
     top: -60px;
   }
   .kv__cell-body {
     width:400px;
     #slider-text-smallscreen {
       letter-spacing: 0px;
     }
     #pl400nepro35pro55_img {
       width: 200px;
       height: auto;
       position:absolute;
       top: 45%;
       left: 20%;
     }
   }
   .menu-back {
     display: none;
   }
 }

 /* ----------- iPhone 6, 6S, 7, 8 and X----------- */
 @media (max-width: 375px) {
   .text_serif_intro {
     font-family: serif;
     letter-spacing: normal;
   }
   .kv-intro__body {
     width: 360px;
   }
   .kv__ttl img {
     width: 360px;
   }
   .kv-intro {
     top: -70px;
   }
   .kv__cell-body {
     width:370px;
     #slider-text-smallscreen {
       font-size: 1.8rem;
       letter-spacing: 0px;
     }
   }
 }

 /* ----------- iPhone 4, 4S, 5, 5S, 5C, 5SE and others with 320px----------- */
 @media (max-width: 320px) {
   .text_serif_intro {
     font-family: serif;
     font-size: 1.2em;
     letter-spacing: -2px;
   }
   .kv-intro__body {
     /* page_home.css line 60 */
     width: 300px;
   }
   .kv__ttl img {
     width: 300px;
   }
   .kv-intro {
     top: -50px;
   }
   .kv__cell-body {
     width:320px;
     #slider-text-smallscreen {
       font-size: 1.4rem;
       letter-spacing: 0px;
     }
     #pl400nepro35pro55_img {
       width: 150px;
       height: auto;
       position:absolute;
       top: 40%;
       left: 20%;
     }
   }
 }
</style>

<style lang="scss" scoped>
 .cosme {
   margin-top: 10px;
   height: 332px;
   /* border: 1px solid #2f609a; */
 }
 .box0 {
   display: flex;
   justify-content: space-between;
 }
 .box1 {
   color: #444;
   /* opacity: 0.5; */
   width: 48%;
   /* margin: 10px; */
   height: 70px;
   border: 1px solid #888;
   display: flex;
   justify-content: center;
   align-items: center;
 }
 .box1 a {
   text-decoration: none;
   display: flex;
   justify-content: center;
   align-items: center;
   /* background: #666; */
   width: 100%;
   height: 100%;
   text-align: center;
 }
 .box1:hover, .cosmetics_banner:hover {
   opacity: 1.0;
   color: #2f609a;
   background: #fff;
   border: 1px solid #2f609a;
   filter: drop-shadow(3px 3px 3px rgba(0,0,0,0.2));
   /* transition: color .55s ease-in-out; */
 }
 dl {
   /* border: 3px double #ccc; */
   padding: 10px;
   font-size: 0.9em;
 }
 dt {
   float: left;
   clear: left;
   width: 40px;
   text-align: right;
   font-weight: bold;
   color: #444;
 }
 dt::after {
   content: " ";
 }
 dd {
   margin: 0 0 0 130px;
   padding: 0 0 0.5em 0;
 }
 .news-media-heading {
   color: #2f609a;
 }
 @media (max-width: 600px) {
   .box0 {
     flex-direction: column;
   }
   .box1 {
     margin-top: 10px;
     width: 100%
   }
   .cosme {
     width: 100%;

     /* deal with extra space at bottom */
     /* img is 960 x 330, 330 / 960 = 0.34375, delete extra 3px */
     height: calc(100vw * 0.34375 - 3px);
   }
   .cosme img {
     width: 100%;
   }
 }

</style>
